/**
 * Configuration for custom keypoint display orders
 *
 * Display order is now primarily driven by the YAML configuration file.
 * The 'customOrder' config reads display_order values from keypoint-schema.yml.
 */

import { getDisplayOrder } from '../config/keypointConfig'

export interface KeypointOrderConfig {
  name: string
  description: string
  // Returns a permutation of indices [0..names.length-1]
  orderFunction: (names: string[]) => number[]
}

export const KEYPOINT_ORDER_CONFIGS: Record<string, KeypointOrderConfig> = {
  default: {
    name: 'Default',
    description: 'Original order',
    orderFunction: names => Array.from({ length: names.length }, (_, i) => i),
  },

  customOrder: {
    name: 'Custom Order',
    description: 'Order defined in YAML configuration (keypoint-schema.yml)',
    orderFunction: _names => getDisplayOrder(),
  },
}

// Default config to use
export const DEFAULT_ORDER_CONFIG = 'customOrder'
